export default ({ currencyCode,  products = [] }, pnrModel) => {
  const { cart } = pnrModel;
  const { travelerCollection } = cart;
  
  let clubpremierIDP = null;
  let balance = null;
  let metricPointsValue = 0;

  if (travelerCollection) {
    clubpremierIDP = travelerCollection[0].ManageUserProfileAccount.account.frequentFlyerNumber;
    balance = travelerCollection[0].ManageUserProfileAccount.account.balance;

    travelerCollection.map(travelerCollectionItem => {
      const ancillaryPath = travelerCollectionItem.ancillaries.ancillaries;

      if (ancillaryPath) {
        ancillaryPath.map(ancillariesItem => {
          if (ancillariesItem.ancillary && ancillariesItem.isPaid === false) {
            if (ancillariesItem.ancillary.redeemedCP === true) {
              metricPointsValue += ancillariesItem.ancillary.getTotalCPPointsPerLeg(ancillariesItem.legCode);
            }
          }
        });
      }
    });
  }

  return clubpremierIDP !== null ? {
    event: 'addToCart',
    ticketNumber: '',
    pointsValue: metricPointsValue,
    pointsCP: balance,
    clubpremierIDP: clubpremierIDP,
    ecommerce: {
      currencyCode: currencyCode,
      add: {
        products: products,
      },
    },
  } : {
    event: 'addToCart',
    ecommerce: {
      currencyCode: currencyCode,
      add: {
        products: products,
      },
    },
  };
};
